import { Flex, Text, IconButton, FlexProps } from '@chakra-ui/react'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { CheckIcon } from '_app/components/Icons'

type OrderOptionsProps = {
  options?: string[];
} & FlexProps;

const OrderOptions: FC<OrderOptionsProps> = ({ options, ...flexProps }) => {
  const { t } = useTranslation('checkout')
  const defaultOptions = [
    t('TWO_DAYS_REALIZATION'),
    t('THIRTY_DAYS_RETURN'),
    t('TWO_YEARS_GUARANTEE'),
    t('CERTIFICATE_OF_AUTHENTICITY'),
  ]

  return (
    <Flex flexDirection="column" my={6} {...flexProps}>
      {(options || defaultOptions).map(option => (
        <Flex as="li" key={option} alignItems="center">
          <IconButton
            aria-label="previous"
            variant="icon"
            icon={<CheckIcon fontSize={10} color="#01c774" />}
          />
          <Text ml={2} textStyle="bodyLight">
            {option}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default OrderOptions
